import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=401a4519&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('401a4519')) {
      api.createRecord('401a4519', component.options)
    } else {
      api.reload('401a4519', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=401a4519&", function () {
      api.rerender('401a4519', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/timber/Index.vue"
export default component.exports